jQuery(document).ready(function ($) {
  'use strict';
  //  TESTIMONIALS CAROUSEL HOOK
  let owl = $('.publisher-carousel-section .owl-carousel');
  $('#customers-testimonials').owlCarousel({
    loop: true,
    // center: true,
    margin: 30,
    autoplay: true,
    autoplayTimeout: 8000,
    autoplayHoverPause: true,
    smartSpeed: 450,
    dotsSpeed: 450,
    navigation: true,
    singleItem: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        slideBy: 1
      },
      768: {
        items: 2,
        slideBy: 2
      },
      1024: {
        items: 3,
        slideBy: 3
      }
    }
  });

  $('.publisher-carousel-section .arrow-left').click(() => owl.trigger('prev.owl.carousel'));
  $('.publisher-carousel-section .arrow-right').click(() => owl.trigger('next.owl.carousel'));
});
